export default {
    ADD_MOYEN_COMMERCIAUX(state, moyenCommerciaux) {
        state.moyenCommerciaux = moyenCommerciaux;
    },
    PUT_MOYENS_COMMERCIAUX(state, moyenCommerciaux) {
        state.moyenCommerciaux = moyenCommerciaux;
    }
};
